import { 
  REQ_LOAN_AGREEMENT, REQ_LOAN_AGREEMENT_DONE, SET_SUCCESS_LOAN_AGREEMENT, 
  SET_ERROR_LOAN_AGREEMENT, GET_DOCS_LOAN_AGREEMENT
} from '../../utils/constants/actionTypes'

const initialState = {
  loading : false,
  error : false,
  errMsg : null,
  success : false,
  docs : null
}

const loanAgreementState = (state = initialState, action) => {
  switch (action.type) {
    case REQ_LOAN_AGREEMENT:
      return {
        ...state,
        loading : true
      }
    case REQ_LOAN_AGREEMENT_DONE:
      return {
        ...state,
        loading : false
      }
    case GET_DOCS_LOAN_AGREEMENT:
      return{
        ...state,
        docs : action.payload,
        loading : false,
        error : false,
        errMsg : null,
        success : false,
      }
    case SET_SUCCESS_LOAN_AGREEMENT:
      return {
        ...state,
        success : true,
        loading : false,
        error : false,
        errMsg : null,
        docs : null
      }
    case SET_ERROR_LOAN_AGREEMENT:
      return {
        ...state,
        error : true,
        errMsg : action.payload,
        loading : false,
        success : false,
        docs : null
      }
    default:
      return state;
  }
}

export { loanAgreementState };